import React, { useState, useEffect, useRef } from "react";
import { usePageTitle } from './hooks/usePageTitle';

function contactusSanitizeName(name: string): [string, boolean] {
  if (name == "") return ["", false];
  let sanitized_name: string = name.trim();

  return [sanitized_name, true];
}

// https://regexr.com/3e48o
const contactusEmailPattern: RegExp = new RegExp(
  "^[\\w\\-.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
);
function contactusSanitizeEmail(email: string): [string, boolean] {
  if (email == "") return ["", false];
  let sanitized_email: string = email.trim();
  let match = sanitized_email.match(contactusEmailPattern);
  if (!match) return [sanitized_email, false];

  return [sanitized_email, true];
}

function contactusSanitizeOrg(organisation: string): [string, boolean] {
  if (organisation == "") return ["", false];
  let sanitized_org: string = organisation.trim();

  return [sanitized_org, true];
}

function contactusSanitizeCountry(country: string): [string, boolean] {
  if (country == "") return ["", false];
  let sanitized_country: string = country.trim();

  return [sanitized_country, true];
}

function contactusSanitizeMessage(message: string): [string, boolean] {
  // no existance check as message can legally be empty
  let sanitized_message: string = message.trim();
  return [sanitized_message, true];
}

function ContactForm() {
  usePageTitle('Contact Us')
  // send states
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const successTimerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (successTimerRef.current) {
        clearTimeout(successTimerRef.current);
        successTimerRef.current = null;
      }
    };
  }, []);

  async function handle_submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const form = e.currentTarget as HTMLFormElement;
    const form_data = new FormData(form);

    // sanitize input values

    let [fmt_name, ok_name] = contactusSanitizeName(
      String(form_data.get("name") || "")
    );
    if (ok_name == false) {
      setError("Invalid Name.");
      setLoading(false);
      return;
    }

    let [fmt_email, ok_email] = contactusSanitizeEmail(
      String(form_data.get("email") || "")
    );
    if (ok_email == false) {
      setError("Invalid Email.");
      setLoading(false);
      return;
    }

    let subject = form_data.get("subject")?.toString() || "";
    if (subject == "") {
      setError("No subject type selected.");
      setLoading(false);
      return;
    }

    let [fmt_org, ok_org] = contactusSanitizeOrg(
      String(form_data.get("organisation") || "")
    );
    if (ok_org == false) {
      setError("Invalid Organisation.");
      setLoading(false);
      return;
    }

    let [fmt_country, ok_country] = contactusSanitizeCountry(
      String(form_data.get("country") || "")
    );
    if (ok_country == false) {
      setError("Invalid Country.");
      setLoading(false);
      return;
    }

    let [fmt_message, ok_message] = contactusSanitizeMessage(
      String(form_data.get("message") || "")
    );
    if (ok_message == false) {
      setError("Invalid Message.");
      setLoading(false);
      return;
    }

    let honey = String(form_data.get("email2") || "") 
    console.log(fmt_name, fmt_email)
    // send post request to FormSpree
    try {
      const formData = new FormData();
      formData.append('name', fmt_name);
      formData.append('email', fmt_email);
      formData.append('subject', subject);
      formData.append('organisation', fmt_org);
      formData.append('country', fmt_country);
      formData.append('message', fmt_message);
      formData.append('email2', honey);

      const res = await fetch("https://formspree.io/f/xzdkoajj", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
        },
        body: formData,
      });

      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        setError(body?.error || `Submission failed (${res.status})`);
        setLoading(false);
        return;
      }

      setLoading(false);
      setError(null);

      // show success decoration for 3 seconds
      if (successTimerRef.current) {
        clearTimeout(successTimerRef.current);
      }
      setShowSuccess(true);
      successTimerRef.current = window.setTimeout(() => {
        setShowSuccess(false);
        successTimerRef.current = null;
      }, 3000);


    } catch (err) {
      setError("Network error - please try again.");
      setLoading(false);
    }
  }

  return (
    <div
      id="ts-contact-us-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-about-us-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full text-2xl flex items-center justify-center p-2">
          Contact Us
        </div>
        <div className="w-full text-normal flex flex-col items-center justify-start p-2 ">
          Please fill in all fields.
        </div>
        <div className="w-3/4 relative items-center justify-center p-4 mt-2 border border-light-border shadow-sm">
          <form
            name="tscontactus"
            method="POST"
            id="ts-contact-us-form"
            onSubmit={handle_submit}
            action="https://formspree.io/f/xzdkoajj"
          >
            {showSuccess && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/40 z-30 pointer-events-none duration-200 ease-in-out">
                <div className="text-light-text-alt">
                  Message Sent
                </div>
              </div>
            )}
            <div
              id="ts-about-us-form-group-name"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-name">Name</label>
              <input
                className="w-full p-2 border-light-border border focus:border-light-main"
                type="text"
                id="ts-about-us-form-name"
                name="name"
                aria-label="Name"
                required
              />
            </div>
            <div
              id="ts-about-us-form-group-email"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-email">Email</label>
              <input
                className="w-full p-2 border-light-border border focus:border-light-main"
                type="email"
                id="ts-about-us-form-email"
                name="email"
                aria-label="Email"
                required
              />
            </div>
            <div
              id="ts-about-us-form-group-subject"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-subject">Subject</label>
              <select
                className="w-full p-2 bg-light-bg border-light-border border focus:border-light-main"
                id="ts-about-us-form-subject"
                name="subject"
                aria-label="Subject"
                required
              >
                <option value="">Please select...</option>
                <option value="salesquery">Sales Query</option>
                <option value="demorequest">Demo Request</option>
                <option value="privacycomments">Privacy Comments</option>
              </select>
            </div>
            <div
              id="ts-about-us-form-group-organisation"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-organisation">
                Organisation
              </label>
              <input
                className="w-full p-2 border-light-border border focus:border-light-main"
                type="text"
                id="ts-about-us-form-organisation"
                name="organisation"
                aria-label="Organisation"
                required
              />
            </div>
            <div
              id="ts-about-us-form-group-country"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-group-country">Country</label>
              <input
                className="w-full p-2 border-light-border border focus:border-light-main"
                type="text"
                id="ts-about-us-form-country"
                name="country"
                aria-label="Country"
                required
              />
            </div>
            <div
              id="ts-about-us-form-group-message"
              className="w-full flex flex-col p-2"
            >
              <label htmlFor="ts-about-us-form-message">Message</label>
              <textarea
                id="ts-about-us-form-message"
                name="message"
                aria-label="Message"
                placeholder="Write your message here..."
                rows={6}
                className="w-full p-2 border-light-border border focus:border-light-main resize-y min-h-24"
              />
            </div>
            <div className="w-full items-center hidden justify-center p-2">
              <input
              className="hidden"
              type="text"
              name="email2"
              placeholder="" />
                
            </div>
            {error && <div className="text-sm text-red-500">{error}</div>}
            <div className="w-full flex items-center justify-center p-2">
              <button
                className="w-1/2 rounded-sm p-2 cursor-pointer bg-light-main text-light-text-alt disabled:opacity-60"
                type="submit"
                disabled={loading}
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
